import React from 'react';
import { CheckCircle2, XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PackElite() {
  const hiitTable = [{
    sin: 'No sabés cómo estructurar una clase de alta intensidad en el agua',
    con: '10 clases HIIT acuáticas completas listas para dar'
  }, {
    sin: 'Tus clases siempre tienen el mismo ritmo e intensidad',
    con: 'Intervalos de trabajo y recuperación listos para usar'
  }, {
    sin: 'No tenés material para alumnas avanzadas que piden más',
    con: 'Entrenamiento funcional acuático de alto impacto'
  }, {
    sin: 'No sabés cómo periodizar intensidad en el agua',
    con: 'Periodización de alta intensidad distribuida en el mes'
  }, {
    sin: 'Alumnas avanzadas se aburren y abandonan',
    con: 'Clases desafiantes que generan fidelidad y resultados'
  }];
  const programTable = [{
    sin: 'No tenés un programa estructurado que mostrarle a tus alumnas',
    con: 'Programa de 90 días semana a semana listo para imprimir o enviar'
  }, {
    sin: 'Tus alumnas no saben qué esperar de las próximas semanas',
    con: '3 niveles incluidos: inicial, intermedio y adultos mayores'
  }, {
    sin: 'No tenés forma de mostrar resultados concretos',
    con: 'Fichas de progreso del alumno para evidenciar mejoras reales'
  }, {
    sin: 'No sabés cómo vender un programa cerrado a tus alumnas',
    con: 'Scripts y estrategias para vender el programa a tu grupo'
  }, {
    sin: 'Tus alumnas no sienten que completaron algo',
    con: 'Certificado de finalización editable para que el alumno sienta el logro'
  }];
  const ComparisonTable = ({
    data,
    title,
    subtitle
  }: {
    data: typeof hiitTable;
    title: string;
    subtitle: string;
  }) => <div className="mb-8 md:mb-16" data-id="element-186">
      <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-187">
        <span className="text-2xl md:text-3xl" data-id="element-188">📗</span>
        <div data-id="element-189">
          <h3 className="text-lg md:text-2xl font-display font-bold text-deepblue-900 leading-tight" data-id="element-190">
            {title}
          </h3>
          <p className="text-slate-500 italic text-xs md:text-base" data-id="element-191">
            "{subtitle}"
          </p>
        </div>
      </div>

      {/* Mobile: stacked cards */}
      <div className="md:hidden space-y-2" data-id="element-192">
        {data.map((row, i) => <div key={i} className="bg-white rounded-lg border border-slate-200 overflow-hidden" data-id="element-193">
            <div className="p-3 flex items-start gap-2 bg-slate-50 border-b border-slate-100" data-id="element-194">
              <XCircle className="w-4 h-4 text-slate-300 flex-shrink-0 mt-0.5" data-id="element-195" />
              <span className="text-slate-500 text-xs line-through" data-id="element-196">
                {row.sin}
              </span>
            </div>
            <div className="p-3 flex items-start gap-2 bg-aqua-50/50" data-id="element-197">
              <CheckCircle2 className="w-4 h-4 text-aqua-600 flex-shrink-0 mt-0.5" data-id="element-198" />
              <span className="text-aqua-900 font-medium text-xs" data-id="element-199">
                {row.con}
              </span>
            </div>
          </div>)}
      </div>

      {/* Desktop: table */}
      <div className="hidden md:block overflow-x-auto rounded-2xl border border-slate-200 shadow-sm" data-id="element-200">
        <table className="w-full text-left border-collapse" data-id="element-201">
          <thead data-id="element-202">
            <tr data-id="element-203">
              <th className="bg-slate-100 p-4 font-bold text-slate-600 w-1/2 border-b border-slate-200" data-id="element-204">
                SIN PACK ÉLITE
              </th>
              <th className="bg-aqua-50 p-4 font-bold text-aqua-900 w-1/2 border-b border-aqua-100" data-id="element-205">
                CON PACK ÉLITE
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-206">
            {data.map((row, i) => <tr key={i} className="hover:bg-slate-50 transition-colors" data-id="element-207">
                <td className="p-4 text-slate-600 flex items-start gap-3" data-id="element-208">
                  <XCircle className="w-5 h-5 text-slate-300 flex-shrink-0 mt-0.5" data-id="element-209" />
                  {row.sin}
                </td>
                <td className="p-4 text-aqua-900 font-medium bg-aqua-50/30" data-id="element-210">
                  <div className="flex items-start gap-3" data-id="element-211">
                    <CheckCircle2 className="w-5 h-5 text-aqua-600 flex-shrink-0 mt-0.5" data-id="element-212" />
                    {row.con}
                  </div>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
  return <section className="py-12 md:py-24 bg-white border-y border-slate-200" data-id="element-213">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-214">
        <FadeIn data-id="element-215">
          <div className="text-center mb-8 md:mb-16" data-id="element-216">
            <h2 className="text-3xl md:text-5xl font-display font-black text-deepblue-900 mb-2 md:mb-4" data-id="element-217">
              ¿Qué agrega el Pack Élite™?
            </h2>
            <p className="text-base md:text-xl text-slate-600" data-id="element-218">
              El sistema para instructores que no solo quieren enseñar — quieren
              crecer
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-219">
          <ComparisonTable data={hiitTable} title="AQUAGYM HIIT Y FUNCIONAL" subtitle="El siguiente nivel: entrenamiento de alta intensidad en el agua" data-id="element-220" />
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-221">
          <ComparisonTable data={programTable} title="PROGRAMA DE 90 DÍAS LISTO PARA ENTREGAR" subtitle="Tu programa completo para vender a tus alumnas como producto propio" data-id="element-222" />
        </FadeIn>
      </div>
    </section>;
}